exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app {\n  min-width: 1200px;\n  display: flex;\n  flex-direction: column;\n  color: #333;\n}\n.app .app-header,\n.app .app-footer {\n  height: 60px;\n  width: 100%;\n}\n.app .app-cont {\n  width: 100%;\n  max-width: 1960px;\n  margin: 0 auto;\n  padding: 0 30px;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.app .app-cont .wrap-all {\n  width: 100%;\n  height: 100%;\n}\n.app .app-cont .wrap-all .ant-spin-container {\n  width: 100%;\n  height: 100%;\n}\n.app .app-cont .wrap-all .ant-layout {\n  overflow: inherit;\n}\n.ant-modal .ant-confirm-content > div {\n  word-wrap: break-word;\n  word-break: normal;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/app/index.less
// module id = 654
// module chunks = 0